






































import Vue from 'vue';
import { merge } from 'lodash';
import { gridSize } from '@/theme/constants';
import ALDialog from './Dialog/ALDialog.vue';

class ButtonOptions {
  left?: {
    text?: string;
  };
  right?: {
    color?: string;
    text?: string;
    icon?: null | string;
    iconOnly?: boolean;
  };
}

export default Vue.extend({
  name: 'ConfirmDialog',

  components: { ALDialog },

  data() {
    return {
      dialog: false,
      title: 'Confirm Dialog',
      message: '',
      resolve: (null as unknown) as (
        value: boolean | PromiseLike<boolean>
      ) => void,
      reject: null as any,
      options: {
        'max-width': 400,
        zIndex: 200
      },
      buttonOptions: {
        text: false,
        left: {
          text: 'Cancel'
        },
        right: {
          color: 'primary',
          text: 'Delete',
          icon: null,
          iconOnly: false
        }
      },
      confirm: false
    };
  },

  computed: {
    hasMessage(): boolean {
      return !!this.message;
    },

    titleWrapperStyles(): Record<string, any> {
      return {
        flexWrap: `nowrap`,
        flex: 1
      };
    },

    titleContainerStyles(): Record<string, any> {
      return {
        minWidth: 0,
        maxWidth: '100%',
        marginBottom: `${this.hasMessage ? gridSize() : 0}px`,
        flexShrink: undefined
      };
    },

    styledTitleStyles(): Record<string, any> {
      return {
        marginTop: 0,
        lineHeight: `${gridSize() * 3.82}px`,
        outline: 'none',
        marginBottom: `${this.hasMessage ? gridSize() : 0}px`
      };
    },

    styledSubTitleStyles(): Record<string, any> {
      return {
        lineHeight: `${gridSize() * 2}px`,
        outline: 'none'
      };
    },

    actionStyles(): Record<string, any> {
      return {
        maxWidth: '100%',
        marginBottom: 'auto',
        marginLeft: 'auto',
        paddingLeft: `${gridSize() * 4}px`,
        flex: '0 0 auto',
        whiteSpace: 'nowrap',
        '>': {
          textAlign: 'right'
        }
      };
    }
  },

  methods: {
    open(
      title?: string,
      buttonOptions?: Partial<ButtonOptions>,
      message?: string,
      confirm = false
    ): Promise<boolean> {
      this.dialog = true;
      message ? (this.message = message) : this.message;
      title ? (this.title = title) : this.title;
      confirm ? (this.confirm = confirm) : this.confirm;
      buttonOptions
        ? (this.buttonOptions = merge(this.buttonOptions, buttonOptions))
        : this.buttonOptions;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
      });
    },

    close() {
      this.confirm = false;
      this.title = '';
    },

    agree() {
      this.dialog = false;
      return this.resolve(true);
    },

    cancel() {
      this.dialog = false;
      return this.resolve(false);
    }
  },

  watch: {
    dialog: {
      handler(val) {
        val || this.close();
      }
    }
  },

  beforeDestroy() {
    this.confirm = false;
  }
});
